export default "__VITE_ASSET__C6c$UoXS__"